import axios from "axios";
import dayjs from "../libs/dayjs";
import { globalVars } from "../libs/global-vars";
import { store } from "../store";
import { AdsResponse, GetAdsParams } from "../types/ads";

const adsInstance = axios.create({
  baseURL: process.env.REACT_APP_FRONTMAN_API_URL,
});

const getAdsHeaders = () => ({
  "App-Code": "tmap",
  Using: "MAIN",
  UserKey: "$userKey",
  euk: store.getState().app.euk,
  "Os-Type": globalVars.osType,
  "Os-Version": globalVars.osVersion,
  "Req-Time": dayjs().format("YYYYMMDDHHmmss"),
  "App-Version": globalVars.appVersion,
  "Model-No": globalVars.isAndroid
    ? globalVars.splitDeviceModel
      ? globalVars.splitDeviceModel[2]
      : "Android"
    : globalVars.deviceModel,
});

export const getMarketingPopupAds = async (
  params: GetAdsParams
): Promise<AdsResponse> => {
  const response = await adsInstance.get<AdsResponse>(
    "/proxy/ads/serving/ads",
    {
      params,
      headers: getAdsHeaders(),
    }
  );

  return response.data;
};

export const requestAdTracking = async (url: string): Promise<void> => {
  await adsInstance.get(url, {
    headers: getAdsHeaders(),
  });
};

export const getHomeBannerAds = async (
  params: GetAdsParams,
  signal?: AbortSignal
): Promise<AdsResponse> => {
  const response = await adsInstance.get<AdsResponse>(
    "/proxy/ads/serving/ads/v3",
    { params, headers: getAdsHeaders(), signal, timeout: 5000 }
  );

  return response.data;
};
